export const PROJECTS_URL = 'https://carellice.github.io/CeccaStore/';

export const redirectToProjects = (location = window.location) => {
    location.replace(PROJECTS_URL);
};
